export const releaseVersion: string = process.env.RELEASE_VERSION!;
